import { Injectable, ViewContainerRef, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";

import { IUser } from "@app/core/auth/identity/user.reducer";
import { SaveInteractionDialogComponent } from "./save-interaction-dialog.component";
import { IDataInteractionsGet, IInteraction } from "@shared/models/interaction.interfaces";

@Injectable({
  providedIn: "root"
})
export class SaveInteractionDialogService {
  private dialog = inject(MatDialog);

  public open(
    viewContainerRef: ViewContainerRef,
    interaction?: IInteraction,
    interactionsGetData?: IDataInteractionsGet,
    currentUser?: IUser,
    fromAllCompanies?: boolean,
    companyName?: string,
    taskId?: string,
    companyId?: string,
    companyUsers?: any,
    isFM?: any
  ): Observable<any> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle", "overflow-visible"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.disableClose = true;
    config.data = {
      interaction: interaction,
      interactionsGetData: interactionsGetData,
      currentUser: currentUser,
      fromAllCompanies: fromAllCompanies,
      companyName: companyName,
      taskId: taskId,
      companyId: companyId,
      companyUsers: companyUsers,
      isFM: isFM
    };
    config.viewContainerRef = viewContainerRef;

    const dialogRef = this.dialog.open(SaveInteractionDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
